"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.openConn = openConn;
exports.proceedMessage = proceedMessage;
exports.waitForClose = waitForClose;
var _reduxSaga = require("redux-saga");
var _effects = require("redux-saga/effects");
var actions = _interopRequireWildcard(require("../actions"));
var _ws = require("../constants/ws");
var _ws2 = _interopRequireDefault(require("../services/ws"));
var _pubsub = _interopRequireDefault(require("../services/pubsub"));
var _auth = require("../utils/auth");
var _snacks = require("../services/snacks");
var _notifications = require("../constants/notifications");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function createSender(ws) {
  return function* sendMsg(action) {
    yield (0, _effects.call)(_ws2.default.send, ws, action.payload);
  };
}
function createListener(chan) {
  return function* listen() {
    while (true) {
      const msg = yield (0, _effects.take)(chan);
      yield (0, _effects.put)(msg);
    }
  };
}
function* waitForClose(senderTask, listener) {
  yield (0, _effects.take)([actions.WS_CLOSED]);
  yield (0, _effects.cancel)(senderTask);
  yield (0, _effects.cancel)(listener);
}
const createSocketEmitter = ws => emit => {
  _ws2.default.onReceive(ws, msg => {
    _pubsub.default.publish(actions.WS_MSG_RECEIVED, msg.data);
    emit(actions.websocketMessageReceived(msg.data));
  });
  _ws2.default.onClose(ws, reason => {
    _pubsub.default.publish(actions.WS_CLOSED, reason);
    emit(actions.websocketClosed(reason));
  });
  return () => _ws2.default.close(ws);
};
function* proceedMessage(action) {
  try {
    const message = yield (0, _effects.call)(JSON.parse, action.payload);
    const parsedMessage = message.encodedContent ? JSON.parse((0, _auth.b64DecodeUnicode)(message.encodedContent)) : null;
    switch (message.type) {
      case _ws.NOTIFICATION:
      case _ws.NOTIFICATION_V2:
        yield (0, _effects.put)(actions.websocketNewNotification(parsedMessage));
        if (!parsedMessage.isRead) {
          yield (0, _effects.put)(actions.setSnack({
            ID: parsedMessage.ID || (0, _auth.randomString)(16),
            target: _notifications.TARGETS.EXTERNAL,
            ...parsedMessage
          }));
        }
        break;
      default:
        throw new Error(`Unknown message type ${message.type}`);
    }
  } catch (error) {
    yield (0, _effects.put)(actions.websocketMessageProceedError(error.message));
  }
}
function* openConn(action) {
  try {
    const ws = yield (0, _effects.call)(_ws2.default.open, action.payload.hostname, action.payload.protocol, action.payload.path);
    yield (0, _effects.put)(actions.websocketOpenSuccess());
    const chan = (0, _reduxSaga.eventChannel)(createSocketEmitter(ws));
    const sender = yield (0, _effects.takeEvery)(actions.WS_MSG_SEND, createSender(ws));
    const listener = yield (0, _effects.fork)(createListener(chan));
    yield (0, _effects.spawn)(waitForClose, sender, listener);
  } catch (error) {
    const locale = yield (0, _effects.getContext)('locale');
    yield (0, _effects.put)(actions.websocketOpenError(error));
    yield (0, _effects.put)(actions.setSnack((0, _snacks.errorSnack)(locale.wsConnectionError || error.message)));
  }
}
function _default() {
  return (0, _effects.all)([(0, _effects.takeLatest)(actions.WS_OPEN_PENDING, openConn), (0, _effects.takeEvery)(actions.WS_MSG_RECEIVED, proceedMessage)]);
}